var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "primary",
      attrs: {
        temporary: "",
        right: _vm.right,
        fixed: "",
        app: "",
        width: "300"
      },
      model: {
        value: _vm.filterDrawer,
        callback: function($$v) {
          _vm.filterDrawer = $$v
        },
        expression: "filterDrawer"
      }
    },
    [
      _c(
        "v-toolbar",
        { staticClass: "primary", attrs: { flat: "", dark: "" } },
        [
          _c("v-toolbar-title", [_vm._v("Filters")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.toggleFilterDrawer($event)
                }
              }
            },
            [_c("v-icon", [_vm._v("$mdiClose")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list",
        {
          staticClass: "primary",
          attrs: { subheader: "", dense: "", dark: "" }
        },
        _vm._l(_vm.filters, function(filter, index) {
          return _c(
            "v-list-group",
            { key: _vm.component + index, attrs: { value: index === 0 } },
            [
              _c(
                "v-list-item",
                { attrs: { slot: "activator" }, slot: "activator" },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.getFilterTypeLabel(filter.type)))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(filter.data, function(item) {
                return [
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-action",
                        [
                          _c("v-checkbox", {
                            attrs: {
                              color: "white",
                              "input-value": !!_vm.isFilterActive(
                                filter.type,
                                item.id
                              ),
                              value: ""
                            },
                            on: {
                              change: function($event) {
                                return _vm.toggleFilter(filter.type, item.id)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            [
                              typeof item.label !== "undefined"
                                ? [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.label) +
                                        "\n                            "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.name) +
                                        "\n                            "
                                    )
                                  ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }